import { setMissingKeyHandler } from '@staiter/i18n';
import type { Locale } from '@staiter/shared';

/**
 * F-A.26 — Sentry-aware missing-key logger.
 * Dev: console.warn.
 * Prod: Sentry.captureMessage (если Sentry инициализирован) — rate-limited.
 */

const seenKeys = new Set<string>();

function report(locale: Locale, key: string) {
  const cacheKey = `${locale}:${key}`;
  if (seenKeys.has(cacheKey)) return;
  seenKeys.add(cacheKey);

  const isDev = typeof import.meta !== 'undefined' && import.meta.env?.DEV;
  if (isDev) {
    console.warn(`[i18n] missing key: ${locale}.${key}`);
    return;
  }
  // prod: прокидываем в Sentry если инициализирован.
  const w = window as unknown as {
    Sentry?: {
      captureMessage: (
        msg: string,
        opts?: { level?: string; tags?: Record<string, string> },
      ) => void;
    };
  };
  if (w.Sentry?.captureMessage) {
    w.Sentry.captureMessage(`i18n.missing_key: ${locale}.${key}`, {
      level: 'warning',
      tags: { locale, key },
    });
  }
}

let installed = false;
export function installMissLogger(): void {
  if (installed) return;
  installed = true;
  setMissingKeyHandler(report);
}
